module.exports = __webpack_public_path__ + "img/testPic.8e6a39de.jpg";